import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '通関書類のアップロードと海上保険',
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
